import { motion } from 'framer-motion';
import heroData from '../../content/hero.json';

const Hero = () => {
  return (
    <section className="relative overflow-hidden py-8">
      {/* Gradient backdrop pour liquid glass - charte Swiss Avengers */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, #f5f5ff 0%, #fffafc 25%, #f8fcff 50%, #fefaff 75%, #f5fbff 100%)',
          opacity: 0.4,
        }}
      />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center py-12">
            {/* Title */}
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-gray-900">
              {heroData.title}
            </h1>

            {/* Subtitle */}
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
              {heroData.subtitle}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
